import Vue from 'vue'
import Vuex from 'vuex'

import config from '@/config'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

import presets from './data/presets.js'
import premiums from './data/premiums.js'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    hideImportOldUser: [
      '105579148151670', //เหยื่อหนู : โบรมาดิโอการ์ด
      '366319550102632', //ไอซีพี ลัดดา
      '314200052001768', //ปุ๋ยม้าบิน
      '2301213226804225' //ไอซีพี เปลี่ยนโลก - ปุ๋ยท็อปวัน
    ],
    loginType:
      Vue.localStorage.get('loginType') && Vue.localStorage.get('loginType') !== 'undefined'
        ? Vue.localStorage.get('loginType')
        : '',
    privilege:
      Vue.localStorage.get('privilege') && Vue.localStorage.get('privilege') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('privilege'))
        : { role: null },
    debug: false,
    edittingIntent: [],
    line: {
      // notify: 'ufgX3KGQ6j1Bclw52yZZkt', // old line notify
      notify: 'vf6yxOil8ZhEDPxgKtZd6c', // line notify

      channelid: '1656186777', // line modular
      clientid: '1656125305' // line login
    },
    foodDelivery: [
      // เปิดใช้ food delivery
      '103733942270168',
      '103434788896471',
      '103449625252826',
      '145969602635827',
      '109008520721534',
      '103209058643189',
      '103195847822433',
      '100160834719075',
      '330946854291292',
      '934400496731284',
      '493004761144617',
      '1924579627803469',
      '2154616301525189',
      '103045347810541',
      '1954711867904582',
      '100855974907941',
      '106853694933201',
      '100645735509364',
      '111154907934759',
      '134182372147489',
      '623635804423191',
      '100437429019988',
      '102183425506822',
      '531287290232237',
      '100619629025288',
      '101350452209241',
      '324885161495477',
      '108209024822196',
      '106229405529976', //ไก่เกาอ่อนนุช
      '104078109126623' //ไก่เกา:สาขาสุรินทร์
    ],
    lalamove: [
      '998122266996445',
      '103449625252826',
      '103434788896471',
      '100619629025288',
      '103733942270168'
    ],
    facebook_info:
      Vue.localStorage.get('facebook_info') && Vue.localStorage.get('facebook_info') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('facebook_info'))
        : null,
    line_info:
      Vue.localStorage.get('line_info') && Vue.localStorage.get('line_info') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('line_info'))
        : null,
    reportInboxMessage: [],
    reportReplyToComment: [],
    reportReplyToInbox: [],
    reportHideToComment: [],
    botStatus: false,
    loading: false,
    newcomer: Vue.localStorage.get('newcomer') === 'true',
    facebook_name: Vue.localStorage.get('facebook_name')
      ? Vue.localStorage.get('facebook_name')
      : Vue.localStorage.get('userid'),
    isLoggedIn: !!Vue.localStorage.get('token'),
    isFacebook: Vue.localStorage.get('FB') === 'true',
    isSelectedBot: !!Vue.localStorage.get('selectedBot'),
    selectedBot:
      Vue.localStorage.get('selectedBot') && Vue.localStorage.get('selectedBot') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('selectedBot'))
        : [],
    userid: Vue.localStorage.get('userid'),
    botlist:
      Vue.localStorage.get('botlist') && Vue.localStorage.get('botlist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('botlist'))
        : [],
    pagelist:
      Vue.localStorage.get('pagelist') && Vue.localStorage.get('pagelist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('pagelist'))
        : [],
    accessToken: Vue.localStorage.get('token'),
    fbAccessToken: Vue.localStorage.get('fbtoken'),
    openSidebar: true,
    paypalTrackingId: Vue.localStorage.get('paypalTrackingId'),
    setting: undefined,
    welcomeMessage: undefined,
    welcomeMessage2: undefined,
    showModalWelcome: Vue.localStorage.get('showModalWelcome'),
    theme: config.theme,
    chatbot: {
      intentGroup: undefined
    },
    loginChannel: ['facebook', 'account', 'chat2pay', 'line'].includes(
      Vue.localStorage.get('loginChannel')
    )
      ? Vue.localStorage.get('loginChannel')
      : 'facebook',
    fbScope: Vue.localStorage.get('fbScope'),
    tutoriallist: [],
    alert:
      Vue.localStorage.get('alerts') && Vue.localStorage.get('alerts') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('alerts'))
        : [],
    partner_code: Vue.localStorage.get('partner_code')
      ? Vue.localStorage.get('partner_code')
      : undefined,
    pageBU: ['114743896611281', '132880665271'],
    specialpage: [
      '619202881423565',
      '2261615673888062',
      '1231805606976542',
      '1493632560856869',
      '2105726733070683',
      '391365474996527',
      '282419538600861',
      '229446640739626',
      '229777340553912',
      '1422119811377985',
      '1441887002726565',
      '367229174088451',
      '2244102365841101'
    ],
    pageRussianRoulette: ['101900391252252', '582769212229333'],
    livepage: [
      '361231620965547',
      '394274810994296',
      '582769212229333',
      '998122266996445',
      '367229174088451',
      '746554075685318',
      '104798401281089',
      '1396503507148739',
      '1589840171084621',
      '100590148401358',
      '102564098201451',
      '105286034592205',
      '106043044515474',
      '106368351149754',
      '107704437498029',
      '101697018243932',
      '103787708076884',
      '100652118659247'
    ],
    linenotifylist: [],
    ecommerce: {
      products: [],
      loadingProduct: true,
      totalProduct: 0,
      categories: [],
      loadingCategory: true,
      charges: {},
      loadingCharges: true
    },
    loadingUserStatus: true,
    userStatus: [],
    loadingUserTags: true,
    userTags: [],
    loadingSetting: true,
    livechatPageList: [],
    livechatPageIdList: [
      // '634199670052309', //Robinson CentralPlaza Ubonratchathani
      // '100169865799063', //CTO CDS Demo page
      // '160733491520', //Central Department Store
      // '361231620965547', //http://Zwiz.AI  แชทบอท
      // '164163116964925', //OnDemand สถาบันกวดวิชาออนดีมานด์
      // '109968900678170', //Maxwell Fix
      // '329688424161461', //วรัทภพ รชตนามวงษ์ http://warattapob.com
      // '104944601303072', //วรัทภพ
      // '101360894725464', //InsureHub
      // '100709785233611', //เงินมาง่ายๆ โดย วรัทภพ
      // '103306351415631', //HR People Connect Thai Union
      // '110332890598171', //Kambukka Thailand
      // '110710877332627', //Central Live Bot"
      // '104665701343082', //TEST Online Vote
      // '367229174088451', //บัวลอย ของดีไอที
      // '746554075685318', //BEAR It สินค้าชั้นดีที่พี่หมีแนะนำ
      // '1493632560856869', //Aston Thailand
      // '110883070374655', //Clever Bot
      // '392612533487', //Robinson Department Store
    ],
    exportProduct: ['998122266996445', '104750531515506'],
    livechat: {
      sessiontoken: '',
      users_unread: {},
      pageid: null,
      line_modular_bot_id: null,
      app: 'facebook',
      type: 'bot',
      line_tab: 'user',
      loadmore: false,
      loadingUser: true,
      show_select_user: false,
      selected_users: [],
      userlist: {
        admin: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        },
        bot: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        }
      },
      monobopages: [
        '148831989096546',
        '1229692217050821',
        '135565533158593',
        '488563718210335',
        '799590883441878'
      ],
      currentUser: null,
      chatlog: [],
      loadingChatlog: true,
      limitFatchChatlog: 20,
      maxFatchChatlogTime: 15000, // 15 sec
      limitFatchUser: 20,
      maxFatchUserTime: 15000, // 15 sec,
      filter: {
        search: '',
        status: null,
        tags: [],
        app: ''
      },
      user: undefined,
      memberGroup: []
    },
    modal: {
      input: {},
      component: null,
      open: false,
      width: '600px'
    },
    allSchools: [],
    presets: presets.data,
    premiums: premiums.data,
    UnlimitedConversation: [
      '100436434784238',
      '103530654454270',
      '1469559653364545',
      '105696154492400',
      '103955724454263', //จี้เส้น
      '177735408970104',
      '102074341651763',
      '100667901640151'
    ],
    pageProfile: null,
    loadingPageProfile: true,
    shippinglist: [],
    partnerProfile: null,
    loadingPartnerProfile: true,
    drJillPage: [
      '1513794172211394', //Dr.JILL_Thailand
      '324684931047327', //Dr.Jill Official
      '189437965174144', //Dr.JILL TH_Shop
      '273202073182478' // Dr.Jill Shop
    ],
    robinsonPage: [
      '634199670052309', //Robinson CentralPlaza Ubonratchathani
      '392612533487', //Robinson Department Store
      '460631194141528', //Robinson Department Store Hatyai
      '291451944586723' // Robinson Department Store Suratthani
    ],
    centralPage: [
      '105516258950290', //test central
      '102855154730088', //Central Department Store CentralFestival Hadyai
      '1322459104509147', //Central Department Store Khonkaen
      '634199670052309', //Robinson CentralPlaza Ubonratchathani
      '460631194141528', //Robinson Department Store Hatyai
      '291451944586723', // Robinson Department Store Suratthani
      '110710877332627',
      '100169865799063',
      '108631281736526',
      '160733491520',
      '107235216024674',
      '394274810994296',
      '392612533487',
      '103551424764072',
      '11462159325207',
      '114621593252079',
      '112085313900804',
      '134297248716',
      '408054729252920',
      '122424499005',
      '102421048239798',
      '105928254552462'
    ],
    menubypageid: {
      '104907684692250': ['comment', 'dashboard']
    },
    supertenpage: ['104665701343082', '154660564561038'],
    facebook_users_name: [],
    subcategory: ['116989963422911', '1775425925847885'],
    livechatadminreadpage: ['394274810994296'],
    filter: {
      search: ''
    },
    niveapage: ['133498913379485', '125865357450484'],
    astonAdmins: [],
    loadingAstonAdmins: false,
    astonCustomerGroup: [
      'อื่นๆ',
      'รอสรุปยอด',
      'ร้องเรียน',
      'เปลี่ยนเบอร์-ที่อยู่',
      'โอนเงิน',
      'สั่งซื้อ',
      'ยกเลิก',
      'สั่งซื้อlive',
      'สนใจ',
      'หลังการขาย',
      'ปัญหา'
    ],
    newDeshboard: ['361231620965547', '100289935418688'],
    delayImportUserTime:
      Vue.localStorage.get('delayImportUserTime') &&
      Vue.localStorage.get('delayImportUserTime') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('delayImportUserTime'))
        : [],

    intents: undefined,
    loadingIntents: true,

    showWelcomeModal: false,
    test_bot: {
      showChat: false,
      channel: 'facebook',
      messages: [],
      contextOut: ''
    },
    loadingWelcome: true,
    loadingGetstarted: true,
    getstarted: undefined,
    gmapapikey: '',
    distances: undefined,
    loadingdistances: true,
    defaultBubbleList: [
      'text',
      'button',
      'image',
      'generic',
      'video',
      'welcome_message',
      'line_flex',
      'line_imagemap',
      'line_sticker',
      'payment_form',
      'pay_solutions_link',
      'add_cart',
      'ntn_template',
      'meta_pay',
    ],
    presetIntentName: [
      'Browse Products/ อัลบัมหมวดหมู่สินค้า',
      'Category 1/ หมวดหมู่ 1',
      'Category 2/ หมวดหมู่ 2',
      'Category 3/ หมวดหมู่ 3',
      'Product details 1/ รายละเอียดสินค้า 1',
      'Product details 2/ รายละเอียดสินค้า 2',
      'Product details 3/ รายละเอียดสินค้า 3',
      'Product details 4/ รายละเอียดสินค้า 4',
      'Product details 5/ รายละเอียดสินค้า 5',
      'Product details 6/ รายละเอียดสินค้า 6',
      'Product details 7/ รายละเอียดสินค้า 7',
      'Product details 8/ รายละเอียดสินค้า 8',
      'Product details 9/ รายละเอียดสินค้า 9',
      'Promotion/โปรโมชั่น',
      'Browse Products/ อัลบัมหมวดหมู่สินค้า',
      'Turnkey_Collect Coupon1/เก็บคูปองโปรโมชั่น1',
      'Turnkey_Collect Coupon2/เก็บคูปองโปรโมชั่น2',
      'Turnkey_Collect Coupon3/เก็บคูปองโปรโมชั่น3',
      'Turnkey_Promotion details1/รายละเอียดโปรโมชั่น1',
      'Turnkey_Promotion details2/รายละเอียดโปรโมชั่น2',
      'Turnkey_Promotion details3/รายละเอียดโปรโมชั่น3',
      'Turnkey_Promotion/โปรโมชั่น',
      'Turnkey_Secret Code/รหัสข้อเสนอพิเศษ'
    ],
    poundCurrency: ['101825731873998'],
    tkBangladeshCurrency: ['109436512005912'],
    usdCurrency: ['100855246124906', '105757739112608', '100203512915939', '111151505282962'],
    phpCurrency: ['197417956782065'],
    paymentGateway: [
      {
        value: 'pg001',
        name_th: 'GB Prime Pay',
        name_en: 'GB Prime Pay',
        image: '/static/img/assets/payment/logo_payment_gateway/3.GB Prime Pay.png'
      },
      {
        value: 'pgother',
        name_th: 'Other',
        name_en: 'Other',
        image: '/static/img/assets/payment/logo_payment_gateway/other.png'
      }
    ],
    eWalletForVerify: [
      {
        value: 'ew001',
        name_th: 'Dolfin Wallet',
        name_en: 'Dolfin Wallet',
        image: '/static/img/assets/payment/logo_e_wallet/1.Dolfin Wallet.jpg'
      },
      {
        value: 'ew002',
        name_th: 'TrueMoney Wallet / WeCard',
        name_en: 'TrueMoney Wallet / WeCard',
        image: '/static/img/assets/payment/logo_e_wallet/2.True-money.jpg'
      },
      {
        value: 'ew003',
        name_th: 'ShopeePay (แอร์เพย์)',
        name_en: 'ShopeePay',
        image: '/static/img/assets/payment/logo_e_wallet/3.ShopeePay.jpg'
      },
      {
        value: 'ew004',
        name_th: 'Rabbit LINE Pay',
        name_en: 'Rabbit LINE Pay',
        image: '/static/img/assets/payment/logo_e_wallet/4.Rabbit LINE Pay.png'
      },
      {
        value: 'ew005',
        name_th: 'พร้อมเพย์ อี-วอลเล็ต / G-Wallet',
        name_en: 'G-Wallet',
        image: '/static/img/assets/payment/logo_e_wallet/ewallet.png'
      }
    ],
    bankForVerify: [
      {
        value: '004',
        name_th: 'ธนาคารกสิกรไทย จำกัด (มหาชน)',
        name_en: 'KASIKORNBANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/3.png'
      },
      {
        value: '006',
        name_th: 'ธนาคารกรุงไทย จำกัด (มหาชน)',
        name_en: 'KRUNG THAI BANK PUBLIC COMPANY LTD.',
        image: '/static/img/assets/payment/logo_bank/4.png'
      },
      {
        value: '002',
        name_th: 'ธนาคารกรุงเทพ จำกัด (มหาชน)',
        name_en: 'BANGKOK BANK PUBLIC COMPANY LTD.',
        image: '/static/img/assets/payment/logo_bank/2.png'
      },
      {
        value: '025',
        name_th: 'ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)',
        name_en: 'BANK OF AYUDHYA PUBLIC COMPANY LTD.',
        image: '/static/img/assets/payment/logo_bank/14.png'
      },
      {
        value: '014',
        name_th: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)',
        name_en: 'SIAM COMMERCIAL BANK PUBLIC COMPANY LTD.',
        image: '/static/img/assets/payment/logo_bank/8.png'
      },
      {
        value: '011',
        name_th: 'ธนาคารทหารไทยธนชาต จำกัด (มหาชน)',
        name_en: 'TMBTHANACHART BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/7.png'
      },
      {
        value: '030',
        name_th: 'ธนาคารออมสิน',
        name_en: 'GOVERNMENT SAVINGS BANK',
        image: '/static/img/assets/payment/logo_bank/18.png'
      },
      {
        value: '024',
        name_th: 'ธนาคารยูโอบี จำกัด (มหาชน)',
        name_en: 'UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/13.png'
      },
      {
        value: '033',
        name_th: 'ธนาคารอาคารสงเคราะห์',
        name_en: 'THE GOVERNMENT HOUSING BANK',
        image: '/static/img/assets/payment/logo_bank/21.png'
      },
      {
        value: '022',
        name_th: 'ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)',
        name_en: 'CIMB THAI BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/11.png'
      },
      {
        value: '017',
        name_th: 'ธนาคารซิตี้แบงก์ เอ็น.เอ.',
        name_en: 'CITIBANK, N.A.',
        image: '/static/img/assets/payment/logo_bank/36.png'
      },
      {
        value: '032',
        name_th: 'ธนาคารดอยซ์แบงก์',
        name_en: 'DEUTSCHE BANK AG.',
        image: '/static/img/assets/payment/logo_bank/20.png'
      },
      {
        value: '066',
        name_th: 'ธนาคารอิสลามแห่งประเทศไทย',
        name_en: 'ISLAMIC BANK OF THAILAND',
        image: '/static/img/assets/payment/logo_bank/37.png'
      },
      {
        value: '069',
        name_th: 'ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)',
        name_en: 'KIATNAKIN PHATRA BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/28.png'
      },
      {
        value: '073',
        name_th: 'ธนาคารแลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)',
        name_en: 'LAND AND HOUSES BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/31.png'
      },
      {
        value: '039',
        name_th: 'ธนาคารมิซูโฮ จำกัด สาขากรุงเทพฯ',
        name_en: 'MIZUHO BANK, LTD. BANGKOK BRANCH',
        image: '/static/img/assets/payment/logo_bank/24.png'
      },
      {
        value: '020',
        name_th: 'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)',
        name_en: 'STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/10.png'
      },
      {
        value: '018',
        name_th: 'ธนาคารซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น',
        name_en: 'SUMITOMO MITSUI BANKING CORPORATION',
        image: '/static/img/assets/payment/logo_bank/9.png'
      },
      {
        value: '071',
        name_th: 'ธนาคารไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)',
        name_en: 'THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/30.png'
      },
      {
        value: '067',
        name_th: 'ธนาคารทิสโก้ จำกัด (มหาชน)',
        name_en: 'TISCO BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/27.png'
      },
      {
        value: '662',
        name_th: 'ธนาคารร่วมพัฒนา จำกัด',
        name_en: 'JOINT DEVELOPMENT BANK LIMITED',
        image: '/static/img/assets/payment/logo_bank/1.png'
      },
      {
        value: '008',
        name_th: 'ธนาคารเจพีมอร์แกน เชส',
        name_en: 'JPMORGAN CHASE BANK, NATIONAL ASSOCIATION',
        image: '/static/img/assets/payment/logo_bank/5.png'
      },
      {
        value: '009',
        name_th: 'ธนาคารโอเวอร์ซี-ไชนีสแบงกิ้งคอร์ปอเรชั่น จำกัด',
        name_en: 'OVER SEA-CHINESE BANKING CORPORATION LIMITED',
        image: '/static/img/assets/payment/logo_bank/6.png'
      },
      {
        value: '023',
        name_th: 'ธนาคารอาร์ เอช บี จำกัด',
        name_en: 'RHB BANK BERHAD',
        image: '/static/img/assets/payment/logo_bank/12.png'
      },

      {
        value: '026',
        name_th: 'ธนาคารเมกะ สากลพาณิชย์ จำกัด (มหาชน)',
        name_en: 'MEGA  INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/15.png'
      },
      {
        value: '027',
        name_th: 'ธนาคารแห่งอเมริกาเนชั่นแนลแอสโซซิเอชั่น',
        name_en: 'BANK OF AMERICA, NATIONAL ASSOCIATION',
        image: '/static/img/assets/payment/logo_bank/16.png'
      },
      {
        value: '029',
        name_th: 'ธนาคารอินเดียนโอเวอร์ซีส์',
        name_en: 'INDIAN OVERSEA BANK',
        image: '/static/img/assets/payment/logo_bank/17.png'
      },
      {
        value: '031',
        name_th: 'ธนาคารฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น จำกัด',
        name_en: 'THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD.',
        image: '/static/img/assets/payment/logo_bank/19.png'
      },
      {
        value: '034',
        name_th: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
        name_en: 'BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES',
        image: '/static/img/assets/payment/logo_bank/22.png'
      },
      {
        value: '035',
        name_th: 'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย',
        name_en: 'EXPORT-IMPORT BANK OF THAILAND',
        image: '/static/img/assets/payment/logo_bank/23.jpg'
      },

      {
        value: '045',
        name_th: 'ธนาคารบีเอ็นพี พารีบาส์',
        name_en: 'BNP PARIBAS',
        image: '/static/img/assets/payment/logo_bank/25.png'
      },
      {
        value: '052',
        name_th: 'ธนาคารแห่งประเทศจีน (ไทย) จำกัด (มหาชน)',
        name_en: 'BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/26.png'
      },
      {
        value: '070',
        name_th: 'ธนาคารไอซีบีซี (ไทย) จำกัด (มหาชน)',
        name_en: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/29.png'
      },

      {
        value: '079',
        name_th: 'ธนาคารเอเอ็นแซด (ไทย) จำกัด (มหาชน)',
        name_en: 'ANZ BANK (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/32.png'
      },
      {
        value: '080',
        name_th: 'ธนาคารซูมิโตโม มิตซุย ทรัสต์ (ไทย) จำกัด (มหาชน)',
        name_en: 'SUMITOMO MITSUI TRUST BANK (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/33.jpg'
      },
      {
        value: '098',
        name_th: 'ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย',
        name_en: 'SMALL AND MEDIUM ENTERPRISE DEVELOPMENT BANK OF THAILAND',
        image: '/static/img/assets/payment/logo_bank/34.jpg'
      }
    ],
    pagePhoneNumberlaos: ['103204011368019'],
    pageMetaVerifySlip: [
      '844584862409516', // my shop demo
      '1214944261858149', //Little Freud リトル フロイト
      '862360750777162', //เรียนจีนตามใจ 随心学汉语
      // '557429034762769', //เคสมือถือ รับสกรีนเคสตามสั่ง By KingCase
      '834418033581271', //Hero Kids Shop
      '113065261014683', //INDEX Game Center บริษัทรับเติมเกมราคาถูก
      '361231620965547'
    ],
    metaVerifySlip: [],
    countAllNotiCustom: {},
    SOCKET_GROUP_GT817: [
      'U85a89e2bf0d80a0ebe0d7f6439225502',
      'Uba55b7ccbeb5ac86a4927cab1eb70799',
      'Ub6e3b0b1eb303bd76e5df2e025185fff',
      'U4a257dc7bdc83475caa1e3d0659eeed8',
      'U0071eeda6f9d41e415006d7c27e25caf',
      'Ubbd3e2e70ad8339424fc35121a98903a'
    ],
    autoLikeComment:[
      '134072728055708',
      '1026520640703501',
      '102789432165931',
      '1617178845071832',
      '1608009539483682'
    ],
    zwizSsoToken: null,
    connect_zerva_business_profile_id: null,
    connect_zerva_shop_profile_setting_id: null,
    connect_zerva_shop_profile_setting_name: null,
    zwizZrmSsoToken: null,
    connect_zrm_business_profile_id: null,
    connect_zrm_shop_profile_setting_id: null,
    connect_zrm_shop_profile_setting_name: null,
    // ISO 4217
    currencies: ['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV', 'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF', 'CHW', 'CLF', 'CLP', 'COP', 'COU', 'CRC', 'CUP', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MXV', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'CNY', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLE', 'SLL', 'SOS', 'SRD', 'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'USN', 'UYI', 'UYU', 'UYW', 'UZS', 'VED', 'VES', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU', 'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XDR', 'XOF', 'XPD', 'XPF', 'XPT', 'XSU', 'XTS', 'XUA', 'XXX', 'YER', 'ZAR', 'ZMW', 'ZWL'],
    isActivePage: false
  },
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js